import { EncryptionErrorCode } from "./encryptionTypes";

import type { ErrorMapping } from "@/errors";
import { ErrorSeverity } from "@/errors";

export const ENCRYPTION_ERROR_MAPPINGS: Record<
  EncryptionErrorCode,
  ErrorMapping
> = {
  encryption_failed: {
    userMessage: "Failed to encrypt data. Please try again.",
    internalMessage: "Encryption operation failed",
    shouldRetry: false,
    severity: ErrorSeverity.Error,
  },
  decryption_failed: {
    // TODO: Add a more specific message for decryption failures
    userMessage: "Failed to decrypt data. Please contact support.",
    internalMessage: "Decryption operation failed",
    shouldRetry: false,
    severity: ErrorSeverity.Error,
  },
};
